module.exports = __webpack_public_path__ + "img/growthAbility10.b87d0937.png";